const ADMIN_VIEW_MODE_KEY = 'admin.viewMode';

export function getAdminViewMode() {
  try {
    const mode = localStorage.getItem(ADMIN_VIEW_MODE_KEY);
    return mode === 'manager' ? 'manager' : 'global';
  } catch {
    return 'global';
  }
}

export function setAdminViewMode(mode) {
  if (mode !== 'global' && mode !== 'manager') return;
  try {
    localStorage.setItem(ADMIN_VIEW_MODE_KEY, mode);
  } catch {}
}

export function getEffectiveIsGlobal(isGlobalUser) {
  if (!isGlobalUser) return false;
  return getAdminViewMode() !== 'manager';
}

